var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 25.1622H25.279C28.6466 25.1622 31.3766 22.4323 31.3766 19.0647C31.3766 18.1318 31.1625 17.2113 30.7509 16.3742L28.1835 11.1528C26.8844 8.5107 24.1962 6.83691 21.252 6.83691H11.0315C8.17744 6.83691 5.55598 8.4107 4.2142 10.9297L1.34228 16.3212C0.878698 17.1915 0.63623 18.1624 0.63623 19.1485C0.63623 22.4698 3.32869 25.1622 6.65 25.1622Z",
    fill: "#E8DEF1",
    stroke: "#510C76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3766 17.6467V25.1622H0.63623V17.6467L6.39429 6.83691H26.0614L31.3766 17.6467Z",
    fill: "#E8DEF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.63623 17.6467V25.1622H31.3766V17.6467M0.63623 17.6467L6.39429 6.83691H26.0614L31.3766 17.6467M0.63623 17.6467H31.3766",
    stroke: "#510C76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.61182,
    y: 20.8467,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.61182,
    y: 20.8467,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6118,
    y: 20.8467,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6118,
    y: 20.8467,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.48,
    y: 20.8467,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0065,
    cy: 11.9097,
    rx: 4.13349,
    ry: 2.96141,
    fill: "white",
    stroke: "#510C76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1792 10.9023L16.8333 12.9195",
    stroke: "#510C76",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.f8df3c55aa66d93544ff2c017ae4c6a3.svg";
export { ForwardRef as ReactComponent };